import React from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { LockTwoTone, UnlockTwoTone } from '@ant-design/icons';

import { UpdateProcTaskStatus } from '../services/workflow';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';

export type TaskUpdateStatusButtonProps = ButtonProps & {
  proctaskid: number;
  status: string;
  refetch: () => void;
};

const TaskUpdateStatusButton: React.FC<TaskUpdateStatusButtonProps> = ({
  size = 'small',
  refetch,
  status,
  proctaskid,
  ...props
}) => {
  const { getComponentLabel } = useDisplayFrameworkContext();

  return (
    <Popconfirm
      title="Are you sure?"
      onConfirm={() => {
        UpdateProcTaskStatus({
          proctaskid,
          taskstatus: status,
        }).then((resp) => {
          if (resp.code === '200') {
            notification.success({ message: resp.message });
            refetch();
          } else {
            notification.error({ message: resp.message });
          }
        });
      }}
      okText="Yes"
      cancelText="No"
    >
      <Button
        icon={
          status === 'INIT' ? (
            <LockTwoTone twoToneColor="#52c41a" />
          ) : (
            <UnlockTwoTone twoToneColor="#00FF00" />
          )
        }
        {...props}
      >
        {status === 'INIT'
          ? getComponentLabel('reopen')
          : getComponentLabel('close')}
      </Button>
    </Popconfirm>
  );
};

export default TaskUpdateStatusButton;
